export default "__VITE_ASSET__Boq8AkwO__"